import { css } from 'styled-components'

export const mapFontFaces = (fontFamily, fontFaces) => css`
  ${fontFaces.map(
    ({ style, weight, src }) => css`
      @font-face {
        font-family: ${fontFamily};
        font-style: ${style};
        font-weight: ${weight};
        src: url(${src}) format('truetype');
      }
    `
  )}
`



// WEBPACK FOOTER //
// ./src/styles/fonts/utils.js